import { render, staticRenderFns } from "./readIndex.vue?vue&type=template&id=313b0bf4&scoped=true&lang=pug"
import script from "./readIndex.vue?vue&type=script&lang=ts"
export * from "./readIndex.vue?vue&type=script&lang=ts"
import style0 from "./readIndex.vue?vue&type=style&index=0&id=313b0bf4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313b0bf4",
  null
  
)

export default component.exports